import { createWebHistory, createRouter } from "vue-router";
import store from "../store";

export const routes = [
    {
        name: "home",
        path: "/",
        component: () => import("../pages/Home.vue"),
        meta: {
            headerPositionContent: true,
        },
    },
    {
        name: "notifications",
        path: "/notifications",
        component: () => import("../pages/notifications/index.vue"),
    },
    {
        name: "notification",
        path: "/notifications/:id",
        component: () => import("../pages/notifications/inner.vue"),
        props: true,
    },
    // {
    //     name: "interes",
    //     path: "/interes",
    //     component: Interisting
    // },
    {
        name: "login",
        path: "/login",
        component: () => import("../pages/auth/NewLogin.vue"),
        meta: {
            hideHeader: true,
            hideFooter: true,
        },
        beforeEnter: (to, from, next) => {
            const storage = JSON.parse(
                JSON.stringify(localStorage.getItem("token"))
            );

            if (storage === "null") {
                return next();
            }

            if (storage !== null) {
                return next({
                    name: "cabinet",
                    params: {
                        returnTo: to.path,
                        query: to.query,
                    },
                });
            }
            next();
        },
    },

    {
        name: "personFilms",
        path: "/personFilms/:provider",
        props: true,
        component: () => import("../pages/single/personFilms.vue"),
    },
    {
        name: "collections",
        path: "/collections/:provider",
        props: true,
        component: () => import("../pages/videos/ConstructorInner.vue"),
    },

    {
        name: "movies",
        path: "/movies",
        component: () => import("../pages/videos/FilmsPage.vue"),
        props: true,
        meta: {
            showFilter: true,
        },
    },

    {
        name: "serials",
        path: "/serials",
        component: () => import("../pages/videos/FilmsPage.vue"),
        props: true,
        meta: {
            showFilter: true,
        },
    },

    {
        name: "kids",
        path: "/kids",
        component: () => import("../pages/videos/FilmsPage.vue"),
        meta: {
            showFilter: true,
        },
    },

    {
        name: "uzb",
        path: "/uzb/:provider",
        component: () => import("../pages/videos/UzbInner.vue"),
    },
    {
        name: "uzb-list",
        path: "/uzb",
        component: () => import("../pages/videos/UzbMoviesList.vue"),
    },

    {
        name: "movie",
        path: "/movie/:id",
        component: () => import("../pages/videos/MoviePage/NewMoviePage.vue"),
        props: true,
        meta: {
            headerPositionContent: true,
        },
    },

    {
        name: "tv",
        path: "/:lang?/tv",
        component: () => import("../pages/tv/TheTv.vue"),
    },
    {
        name: "channel",
        path: "/:lang?/channel/:id",
        component: () => import("../pages/tv/NewChannelPage.vue"),
        props: true,
        meta: { hideFooter: true },
    },
    {
        name: "my",
        path: "/my/:slug",
        component: () => import("../pages/videos/My/index.vue"),
        beforeEnter: (to, from, next) => {
            const storage = JSON.parse(
                JSON.stringify(localStorage.getItem("token"))
            );

            if (!storage) {
                return next({
                    name: "login",
                });
            }
            next();
        },
    },
    {
        name: "search",
        path: "/search",
        component: () => import("../pages/videos/newSearch.vue"),
    },
    {
        name: "tvArchive",
        path: "/tvArchive/:id/:archiId",
        props: true,
        component: () => import("../pages/videos/TvArchive/index.vue"),
    },
    {
        name: "tvArchiveInner",
        path: "/tvArchiveInner/:id/:archiId/:time",
        props: true,
        component: () => import("../pages/videos/TvArchive/inner.vue"),
    },
    {
        name: "cabinet",
        path: "/cabinet",
        component: () => import("../pages/auth/Cabinet.vue"),
    },
    {
        name: "payment-history",
        path: "/cabinet/payment-history",
        component: () => import("../pages/auth/PaymentHistory.vue"),
    },
    {
        name: "about",
        path: "/about",
        component: () => import("../pages/single/About.vue"),
    },
    {
        name: "answers",
        path: "/answers",
        component: () => import("../pages/single/Answers.vue"),
    },
    {
        name: "android",
        path: "/android",
        component: () => import("../pages/single/Android.vue"),
    },
    // {
    //     name: "ios",
    //     path: "/ios",
    //     component: Ios
    // },
    {
        name: "job",
        path: "/job",
        component: () => import("../pages/single/Job.vue"),
    },
    {
        name: "Lg",
        path: "/lg",
        component: () => import("../pages/single/Lg.vue"),
    },
    {
        name: "Pay",
        path: "/pay",
        component: () => import("../pages/single/Pay.vue"),
    },
    {
        name: "Samsung",
        path: "/samsung",
        component: () => import("../pages/single/Samsung.vue"),
    },
    {
        name: "Tariff",
        path: "/tariff",
        component: () => import("../pages/single/Tariff.vue"),
    },

    {
        name: "policy",
        path: "/policy",
        component: () => import("../pages/single/Politic.vue"),
    },

    {
        name: "password",
        path: "/password",
        component: () => import("../pages/auth/Password.vue"),
    },
    // {
    //     name: "PodpiskaTv",
    //     path: "/subscription",
    //     component: () => import("../pages/tv/PodpiskaTv.vue"),
    // },

    {
        path: "/:lang?/news",
        name: "blogs",
        props: true,
        component: () => import("../pages/single/Blogs.vue"),
    },
    {
        name: "news",
        path: "/:lang?/news/:id",
        component: () => import("../pages/single/CurrentNews.vue"),
        props: true,
    },

    {
        path: "/:pathMatch(.*)*",
        name: "404",
        component: () => import("../pages/single/NotFoundPage.vue"),
        meta: { hideFooter: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    mode: "history",
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

router.beforeEach(async (to, from, next) => {
    const temp = store.getters.seoData.data;
    const seo = temp[to.fullPath];
    if (seo) {
        document.title = seo?.title;
        document
            .querySelector('meta[name="description"]')
            ?.setAttribute("content", seo?.desc);
    } else {
        if (temp["/"]) {
            document.title = temp["/"]?.title;
            document
                .querySelector('meta[name="description"]')
                ?.setAttribute("content", temp["/"]?.desc);
        }
    }
    if (to.name === "cabinet" || to.name === "login") {
        store.commit("CLEAR_CHANELS");
    }

    next();
});

export default router;
